<template>
  <v-card>
    <v-card-title>
      <span>Website Status</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <h2>Production</h2>
        </v-row>
        <v-row v-if="data.prod">
          <p v-if="data.prod.last_build">{{ timeAgo(data.prod.last_build) }}
            <span class="grey--text">({{ data.prod.last_build }})</span>
          </p>
          <v-spacer></v-spacer>
          <v-chip v-if="data.prod.building" label color="primary">Copy in progress</v-chip>
          <v-btn v-else primary @click="triggerBuild('prod')">Deploy</v-btn>
        </v-row>
        <v-row class="mt-4">
          <h2>Development</h2>
        </v-row>
        <v-row v-if="data.dev">
          <p v-if="data.dev.last_build">{{ timeAgo(data.dev.last_build) }}
            <span class="grey--text">({{ data.dev.last_build }})</span>
          </p>
          <v-spacer></v-spacer>
          <v-chip v-if="data.dev.building" label color="primary">Build in progress</v-chip>
          <v-btn v-else primary @click="triggerBuild('dev')">Build</v-btn>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="$emit('close')">Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import * as api from '@/api'

export default {
  name: 'WebsiteStatus',
  props: {
    open: { type: Boolean, default: false }
  },
  data() {
    return {
      timeout: null,
      data: {}
    }
  },
  watch: {
    open(val) {
      if (val) this.onOpen()
      else this.onClose()
    }
  },
  methods: {
    async getStatus() {
      this.data = await api.get('/website/build/status')
      if (this.open) {
        this.timeout = setTimeout(() => {
          return this.getStatus()
        }, 1000)
      }
    },
    timeAgo(ts) {
      if (!ts) return ''
      const s = Math.floor((Date.now() - new Date(ts)) / 1000)
      if (s < 60) return `${s}s ago`
      if (s < 3600) return `${Math.floor(s / 60)}m ago`
      if (s < 86400) return `${Math.floor(s / 3600)}h ago`
      return `${Math.floor(s / 86400)}d ago`
    },
    triggerBuild(v) {
      return api.post(`/website/build/trigger/${v}`)
    },
    onOpen() {
      this.getStatus()
    },
    onClose() {
      if (this.timeout) {
        clearTimeout(this.timeout)
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
